import React, { useEffect, useContext } from 'react'
import Header from '../../components/Header'
import { GeneralContext } from '../../context/'

const Index = () => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    useEffect(() => {
        window.analytics.page('Vendora visited waiting list page')
        setLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <Header />
            <section className="signup-body">
                <section className="centered">
                    <h1>Por ahora, todavía NO estamos en tu país.</h1>

                    <p>Desde este momento ya eres parte de nuestra comunidad. Te mantendremos informada de nuestro lanzamiento en tu país.</p>

                    <p>No es necesario que crees otra cuenta, tu cuenta ya está registrada con tu numero de Whatsapp.</p>

                    <p>El acceso actualmente está limitado a usuarias con Residencia en México pero estamos trabajando para tener más países disponibles muy pronto.</p>

                    <p><strong>Te invitamos a seguirnos en redes sociales como Facebook e Instagram para estar enterada de nuestro progreso y noticias.</strong></p>

                    <nav style={{
                        textAlign: 'center',
                        paddingTop: '24px'
                    }}>
                        <a href="https://www.facebook.com/VendoraMexico"><img width={48} alt={``} src="https://storage.googleapis.com/vendora-storage/assets/images/facebook.png" /> </a>
                        <a href="https://www.instagram.com/vendoramx/"><img width={48} alt={``} src="https://storage.googleapis.com/vendora-storage/assets/images/instagram.png" /> </a>
                        <a href="https://www.linkedin.com/company/vendora-latam"><img width={48} alt={``} src="https://storage.googleapis.com/vendora-storage/assets/images/linkedin.png" /></a>
                    </nav>
                </section>
            </section>
        </React.Fragment>
    )
}

export default Index